export const Surfaces = [
  { id: 1, text: 'Beach' },
  { id: 2, text: 'Grass' },
  { id: 3, text: 'Indoor' },
  { id: 4, text: 'Clay' },
  { id: 5, text: 'Hard Court' }
]
